import { Link } from "react-router-dom";

const LOGO_URL = "https://static.readdy.ai/image/2e5ed1f19dde2fb934edeb3dd74e6746/24dfb05c0546ee27bc00ddff95f3527a.png";

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-navy-100">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img
              src={LOGO_URL}
              srcSet={`${LOGO_URL} 48w`}
              sizes="48px"
              alt="ShopVitrineWeb"
              className="shrink-0 rounded-full"
              width={48}
              height={48}
              loading="lazy"
              decoding="async"
            />
            <span className="font-display text-2xl text-white">
              Shop<span className="text-coral-300">Vitrine</span>Web
            </span>
          </div>
          <p className="text-sm text-navy-200 leading-relaxed max-w-md">
            Nous créons des sites vitrine élégants et sur-mesure pour votre activité.
            Un design professionnel, une mise en ligne rapide et un accompagnement humain.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-white mb-4 tracking-wide text-sm uppercase">
            Navigation
          </h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-coral-300 cursor-pointer">Accueil</Link></li>
            <li><Link to="/realisations" className="hover:text-coral-300 cursor-pointer">Univers de création</Link></li>
            <li><Link to="/contact" className="hover:text-coral-300 cursor-pointer">Contact</Link></li>
          </ul>
        </div>

        <div className="min-w-0 md:-ml-6">
          <h3 className="font-semibold text-white mb-4 tracking-wide text-sm uppercase">
            Contact
          </h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3 min-w-0">
              <i className="ri-mail-line text-coral-300 mt-0.5"></i>
              <span className="whitespace-nowrap">contact@shopvitrineweb.fr</span>
            </li>
            <li className="flex items-start gap-3 min-w-0">
              <a
                href="https://wa.me/33763297694"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Discuter sur WhatsApp"
                title="Discuter sur WhatsApp"
                className="mt-0.5 w-5 h-5 flex items-center justify-center rounded-full bg-[#25D366] text-white hover:brightness-110 cursor-pointer transition-all shrink-0"
              >
                <i className="ri-whatsapp-fill text-xs"></i>
              </a>
              <a
                href="https://wa.me/33763297694"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="hover:text-coral-300 cursor-pointer"
              >
                WhatsApp
              </a>
            </li>
            <li className="flex items-start gap-3 min-w-0">
              <i className="ri-map-pin-line text-coral-300 mt-0.5"></i>
              <span>France</span>
            </li>
            <li className="flex items-start gap-3 min-w-0">
              <i className="ri-time-line text-coral-300 mt-0.5"></i>
              <span>Lun. – Ven. · 9h – 18h</span>
            </li>
            <li className="flex items-start gap-3 min-w-0">
              <i className="ri-time-line text-coral-300 mt-0.5"></i>
              <span>Samedi · 10h – 18h</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-navy-800">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-navy-300">
          <p>© {new Date().getFullYear()} ShopVitrineWeb. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="text-navy-400 hover:text-navy-200 cursor-pointer no-underline transition-colors">Mentions légales</Link>
            <Link to="/cgv" className="text-navy-400 hover:text-navy-200 cursor-pointer no-underline transition-colors">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}